var map = {
	"./image-not-found.jpg": 848,
	"./logo-venue-1.png": 431,
	"./logo-venue-2.png": 700,
	"./logo-venue-3.png": 213,
	"./stage-1.png": 496,
	"./za-1.png": 959,
	"./zb-1.png": 772,
	"./zc-1.png": 753,
	"./zv-1.png": 88
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 348;